import Alt from "alt/src/index";
export default new Alt();
